import { useMemo } from 'react';

import { SongMediaImage } from '@/core/db.ts';

interface MediaImageProps {
  mediaFile: SongMediaImage;
}

function MediaImage({ mediaFile }: MediaImageProps) {
  const base64Image = useMemo(() => {
    if (!mediaFile || !mediaFile.contents) {
      return '';
    }

    const blob = new Blob([mediaFile.contents], { type: 'image/webp' });

    return URL.createObjectURL(blob);
  }, [mediaFile]);

  return (
    <img alt="Song media" className="w-full" src={base64Image} />
  );
}

export default MediaImage;
